// Imports

import { UserProfile } from "src/modules/user-profile/jsx/component.jsx";
import { NavigationMenu } from "src/modules/navigation/jsx/component.jsx";


// Stateful components

export function NavigationPanel(props) {

    //
    // Render
    //

    return (
        <div className="nav-panel">
            <UserProfile />
            <NavigationMenu />
        </div>
    );

};
